// System notices — fetching, and remembering what the user has already dismissed.
//
// The message this replaces was hardcoded in a component, shown as a blocking modal, and reset
// on every login, so dismissing it never stuck. Here the text comes from the server (ops can
// edit or switch it off without a deploy) and the dismissal is keyed to the notice's identity
// AND version: bump the version and an edited notice reappears for everyone; leave it alone and
// nobody is nagged twice.
import axios from "axios";

const DISMISSED_KEY = "dismissedNotices";
const DEFAULT_LANGUAGE = "ENG";

function dismissalId(notice) {
  return notice.notice_key + ":" + notice.version;
}

function readDismissed() {
  try {
    const raw = localStorage.getItem(DISMISSED_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    // Corrupt or unavailable storage just means nothing is remembered.
    return [];
  }
}

export function isDismissed(notice) {
  return readDismissed().indexOf(dismissalId(notice)) !== -1;
}

export function rememberDismissal(notice) {
  const id = dismissalId(notice);
  const current = readDismissed();
  if (current.indexOf(id) !== -1) return;
  try {
    // A new array rather than push() — the stored value is replaced, not mutated in place.
    localStorage.setItem(DISMISSED_KEY, JSON.stringify(current.concat([id])));
  } catch (e) {
    // Storage refused (private browsing): the notice simply returns next load.
  }
}

export async function fetchActiveNotices() {
  let token = null;
  let language = DEFAULT_LANGUAGE;
  try {
    token = localStorage.getItem("token");
    language = localStorage.getItem("lang") || DEFAULT_LANGUAGE;
  } catch (e) {
    // fall through with the defaults
  }
  if (!token) return [];
  try {
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_URL + "/v1/notices/active",
      { token: token, language: language }
    );
    const data = response.data && response.data.data;
    return Array.isArray(data) ? data : [];
  } catch (e) {
    // Never surface this: a banner failing to load must not put an error on the page. A revoked
    // session is handled by sessionGuard's interceptor, not here.
    return [];
  }
}
